import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Observable} from "rxjs";

import {ViewBreakpointService, ViewSize} from '@common-module/app-services/view-breakpoint.service';
import {UnitAdditionalData} from '@common-module/modelinterfaces/unit-additional-data.model';
import {
  EditUnitViewDialogComponent
} from '../../../vehicle/unit-view-tab/edit-unit-view-dialog/edit-unit-view-dialog.component';
import {
  EditCertificateDialogOpener
} from "@common-module/app-components/edit-certificate-dialog/edit-certificate-dialog.opener";
import {
  EditCertificateDialogData
} from "@common-module/app-components/edit-certificate-dialog/edit-certificate-dialog.component";
import {UnitDataService} from "../../../../../shared/services/unit-data.service";
import {take} from "rxjs/operators";
import {PermissionsSecurityService} from "../../../../../shared/services/permissions-security.service";
import {FeatureKey} from "@common-module/modelinterfaces/enums/feature-key";
import { NgClass, AsyncPipe } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { CertificateExpireComponent } from '@common-module/app-components/certificate-expire/certificate-expire.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-unit-info-card',
    templateUrl: './unit-info-card.component.html',
    styleUrls: ['../carousel-card-styles.component.scss', './unit-info-card.component.scss'],
    imports: [NgClass, MatTooltip, MatIcon, CertificateExpireComponent, AsyncPipe, TranslateModule]
})

export class UnitInfoCardComponent implements OnInit {

  @Input() width: number;
  @Input() unitData: UnitAdditionalData;

  public size$: Observable<ViewSize> = this.viewBreakpointService.size$;
  public isUnitVewEditable: boolean = true;

  constructor(private dialog: MatDialog,
              private viewBreakpointService: ViewBreakpointService,
              private unitDataService: UnitDataService,
              private editCertificateOpener: EditCertificateDialogOpener,
              private cdr: ChangeDetectorRef,
              private permissionsSecurityService: PermissionsSecurityService) {
  }

  public ngOnInit(): void {
    this.isUnitVewEditable = this.permissionsSecurityService.isAllowed(FeatureKey.FLEET);
  }

  public onEdit(): void {
    this.dialog.open(EditUnitViewDialogComponent, {
      width: '350px',
      autoFocus: false,
      data: {
        unit: this.unitData.unit
      }
    });
  }

  onEditCertificate() {
    const data = {
      unit: this.unitData.unit,
      deleteDisable: true
    } as EditCertificateDialogData;
    this.editCertificateOpener.open({data}).pipe(take(1))
      .subscribe(result => {
        if (!result || result.isCancel || !result.data) {
          return;
        }

        this.unitDataService.changeUnit(result.data);
      });
  }
}
